import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import PropTypes from 'prop-types';
import React, { useRef, useState, useEffect } from 'react';

var cache = {};
var https = location.protocol === 'https:';

function ajax(_ref) {
  var _ref$method = _ref.method,
      method = _ref$method === void 0 ? 'GET' : _ref$method,
      url = _ref.url,
      withCredentials = _ref.withCredentials,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? null : _ref$data;
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    xhr.withCredentials = withCredentials;

    xhr.onload = function () {
      var result;

      try {
        result = JSON.parse(xhr.responseText);
      } catch (e) {
        reject(e);
        return;
      }

      resolve(result);
    };

    xhr.onerror = reject;
    xhr.send(data);
  });
}

function MicroApp(_ref2) {
  var production = _ref2.production,
      context = _ref2.context,
      params = _ref2.params,
      pageId = _ref2.pageId;
  var ref = useRef();

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  useEffect(function () {
    var unmount = false;
    var app;

    var main = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var productUrl, getUserInfo, getProduct;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                getUserInfo = Promise.resolve();

                if (!window.GEP_USER_INFO) {
                  getUserInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    var _yield$ajax, _yield$ajax$body, pin, msg;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return ajax({
                              url: https ? '//jdsq-yf2.jd.com/datamix/user/base/info' : '//ge.back.jd.com/datamix/user/base/info',
                              withCredentials: true
                            });

                          case 2:
                            _yield$ajax = _context.sent;
                            _yield$ajax$body = _yield$ajax.body;
                            _yield$ajax$body = _yield$ajax$body === void 0 ? {} : _yield$ajax$body;
                            pin = _yield$ajax$body.pin, msg = _yield$ajax.msg;
                            window.GEP_USER_INFO = {
                              pin: pin
                            }; // 如果没有pin，设置错误

                            if (!pin) {
                              setError(msg);
                            }

                          case 8:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }))();
                }

                if (production) {
                  getProduct = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                    var _yield$ajax2;

                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return ajax({
                              url: "//".concat(https ? 'jdsq-yf2.jd.com' : 'ge.back.jd.com', "/hjycenter/api/ducc/micro-app?itemId=").concat(pageId),
                              withCredentials: true
                            });

                          case 2:
                            _yield$ajax2 = _context2.sent;
                            productUrl = _yield$ajax2.data;

                          case 4:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }))();
                } else {
                  getProduct = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                    var _yield$ajax3, _yield$ajax3$data;

                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return ajax({
                              url: "//psp-server-yf.jd.com/api/product/get?pageId=".concat(pageId)
                            });

                          case 2:
                            _yield$ajax3 = _context3.sent;
                            _yield$ajax3$data = _yield$ajax3.data;
                            _yield$ajax3$data = _yield$ajax3$data === void 0 ? {} : _yield$ajax3$data;
                            productUrl = _yield$ajax3$data.product_url;

                          case 6:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }))();
                }

                _context4.next = 5;
                return Promise.all([getUserInfo, getProduct]);

              case 5:
                if (!Object.prototype.hasOwnProperty.call(cache, productUrl)) {
                  cache[productUrl] = new Promise(function (resolve) {
                    var script = document.createElement('script');
                    script.src = productUrl;

                    script.onload = function () {
                      document.body.removeChild(script);
                      resolve(window.__microApp__);
                    };

                    document.body.appendChild(script);
                  });
                }

                cache[productUrl].then(function (mount) {
                  if (!unmount) {
                    app = mount(ref.current, {
                      context: context,
                      params: params
                    });
                  }
                });

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function main() {
        return _ref3.apply(this, arguments);
      };
    }();

    main();
    return function () {
      unmount = true;

      if (app) {
        app.unmount && app.unmount();
      }
    };
  }, [pageId]);

  if (error) {
    return /*#__PURE__*/React.createElement("div", null, error);
  }

  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  });
}
MicroApp.propTypes = {
  context: PropTypes.object,
  params: PropTypes.object,
  pageId: PropTypes.string,
  production: PropTypes.bool
};
MicroApp.defaultProps = {
  context: null,
  params: null,
  pageId: null,
  production: false
};

export { MicroApp as default };
